// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__1IAvy","header":"styles_header__2kgz4"};